export function log(msg: string, categroy?: string): void {
  console.log(
    '%c cs portal ',
    'background:#ee4d2d;color:#fff;border-radius: 5%;',
    `%c ${categroy || ''}`,
    'background:#f0ad4e;color:#fff;border-radius: 5%;',
    `${msg}`,
  );
}

export function error(msg: string, categroy?: string): void {
  console.error(
    `%c ${categroy || 'cs portal'} `,
    'background:#ee4d2d;color:#fff;border-radius: 5%;',
    `${msg}`,
  );
}

export function warning(msg: string): void {
  console.warn(
    '%c cs portal ',
    'background:#ee4d2d;color:#fff;border-radius: 5%;',
    `${msg}`,
  );
}
